import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-error-small-modal',
    templateUrl: './error-small-modal.component.html',
    styleUrls: [],
})
export class ErrorSmallModalComponent {
    @Input() title: string;
    @Input() content: string;
    @Input() closeButton: string;
    @Input() visibility: boolean;

    @Output() visibilityChange: EventEmitter<boolean> = new EventEmitter();

    closeModal(): void {
        this.visibility = false;
        this.visibilityChange.emit(this.visibility);
    }
}
